export default __webpack_public_path__ + "static/media/05.23b472e9.jpg";